import { Col, Table } from "antd";

const VehicleHealthTable = ({
  vehiclePartList,
  partsHovered,
  handleMouseEnterRow,
  handleMouseLeaveRow,
}) => {
  const getRowClassName = (partType) => {
    let rowClassName = "";
    if (partsHovered[partType]) {
      rowClassName = "row-selected";
    }
    return rowClassName;
  };

  const columns = [
    {
      title: "Vehicle Parts",
      dataIndex: "partType",
      key: "partType",
      className: "grey imei-text bold pl1",
      render: (_, record) =>
        ` ${
          record?.partType.slice(0, 1) +
          record?.partType.slice(1, record?.partType.length).toLowerCase()
        } ${record?.partType === "TYRE" ? " Pressure" : ""}`,
    },
    {
      title: "Health Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      className: "display-flex",
      render: (status) => {
        const statusStr =`${
          status.slice(0, 1) +
          status.slice(1, status.length).toLowerCase()
        }`
        return <div className={statusStr + "-tag ml1"}>{status}</div>
      },
    },
  ];

  return (
    <Col span={24} className="vehicle-part-table p0 mt1">
      <Table
        columns={columns}
        dataSource={vehiclePartList}
        pagination={false}
        showHeader={false}
        rowKey={(row) => row?.partType}
        scroll={{ y: "400px" }}
        onRow={(row, rowindex) => {
          return {
            onMouseEnter: (e) => {
              handleMouseEnterRow(rowindex, row);
            },
            onMouseLeave: handleMouseLeaveRow,
          };
        }}
        rowHoverable={false}
        rowHoverBg="#ebedf0"
        className="pl05"
        rowClassName={(row) => getRowClassName(row?.partType?.toUpperCase())}
      />
    </Col>
  );
};

export default VehicleHealthTable;
